import { FC } from 'react';
import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import Spacing from 'components/Spacing';
import api from 'lib/trpcClient';
import FirmUserFormFields from './FirmUserFormFields';

const FirmUserForm: FC = () => {
  const { id } = useParams<{ id?: string }>();

  const firmUser = api.adminUser.getUserInCurrentFirm.useQuery(
    { adminUserId: id ?? '' },
    { enabled: !!id },
  );

  const breadcrumbs = [
    { label: 'Dashboard' },
    { label: 'Users', link: '/admin-user' },
    {
      label: id ? 'Update User' : 'Add User',
      link: '/',
      isActive: true,
    },
  ];

  return (
    <PageContainer
      heading={id ? 'Update User' : 'Add User'}
      breadcrumbs={breadcrumbs}
      loading={!!(id && firmUser.isLoading)}
    >
      <PageContent>
        <Spacing>
          <FirmUserFormFields id={id} firmUser={firmUser.data} />
        </Spacing>
      </PageContent>
    </PageContainer>
  );
};

export default FirmUserForm;
